<template>
  <div>
    <v-row class="text-center">
      <v-col cols="3" class="mx-auto py-0">
        <v-btn
          text
          small
          class="text-capitalize"
          @click="timeframe = 'recently'"
          :class="timeframe == 'recently' ? 'accent--text ' : ''"
        >
          Recently
        </v-btn>
      </v-col>
      <v-col cols="5" class="mx-auto py-0">
        <v-btn
          text
          small
          class="text-capitalize"
          @click="timeframe = 'all_time'"
          :class="timeframe == 'all_time' ? 'accent--text ' : ''"
        >
          All time
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      class="pa-1 text-left"
      v-if="top_users && top_users[timeframe]"
      :style="{ maxHeight: $vuetify.breakpoint.xs ? '200px' : '' }"
    >
      <v-col
        cols="12"
        v-for="(user, index) in top_users[timeframe]"
        :key="user.id"
        class="pa-1 ml-3"
      >
        <span v-if="index == 0">🎖</span>
        <span v-if="index == 1">🥈</span>
        <span v-if="index == 2">🥉</span>
        <span v-if="index > 2">{{ index + 1 }}.</span> {{ user.author }}
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SendRequestMixin from "../mixins/SendRequestMixin";

export default {
  name: "TheTopUsers",
  mixins: [SendRequestMixin],
  data() {
    return {
      top_users: [],
      timeframe: "recently"
    };
  },
  computed: {},
  methods: {
    getData() {
      this.sendRequest({
        endpoint: "/top_users",
        store_as: "top_users",
        list: true
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="sass">
.latestRelease
	max-height: 30vh
	overflow-x: hidden
	overflow-y: overlay
</style>
